module.exports = __webpack_public_path__ + "static/media/ke.c244db15.svg";